import { GlobalContext } from 'GlobalContext';
import { useFilter } from './AssetManagerContext';
import { useState, useEffect, useContext } from 'react';
import { isAdmin, isPhoneSize } from 'utils/util';
import { PropertyInfo } from './PropertyManagement/PropertyInfo';
import { Input, Button, Dropdown } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { AllInfoExpanded } from './AllInfoComprehensive/AllInfoExpanded';
import { ViewSelectionMenu } from './TableControl/ViewSelectionMenu';
import { ColumnVisibilityMenu } from './TableControl/ColumnVisibilityMenu';
import { Filter } from './TableControl/Filter';
import { GroupBy } from './TableControl/GroupBy';

export function PropertyManager() {
    const { manageAssetId, setManageAssetId, accessToken, globalId } =
        useContext(GlobalContext);
    // const [filteredText, setFilteredText] = useState('');
    const { filteredText, setFilteredText } = useFilter();
    const [customerPropertyIds, setCustomerPropertyIds] = useState(new Set());
    const [mainTableView, setMainTableView] = useState('basic');
    const [inputValue, setInputValue] = useState('');

    const { Search } = Input;

    const applyFilter = () => {
        setFilteredText(inputValue.trim().toLowerCase());
    };

    const clearFilter = () => {
        setInputValue('');
        setFilteredText('');
    };

    useEffect(() => {
        if (inputValue === '') {
            setFilteredText('');
        }
    }, [inputValue]);

    return (
        <>
            {manageAssetId === 0 && (
                <>
                    {/* map control */}
                    <div
                        style={{
                            width: '300px',
                            display: 'flex',
                            flexDirection: 'row',
                            width: 'fit-content',
                            marginLeft: '20px',
                        }}
                    >
                        {isAdmin() && (
                            <Button
                                type="default"
                                icon={<PlusOutlined />}
                                onClick={() => setManageAssetId(-1)}
                            >
                                Add
                            </Button>
                        )}
                        <Filter />
                        <ViewSelectionMenu />
                        <ColumnVisibilityMenu />
                        <GroupBy />
                    </div>

                    {/* Scrollable content area for tables */}
                    <div
                        style={{
                            maxHeight: isPhoneSize()
                                ? 'calc(100vh - 327px)'
                                : 'calc(100vh - 48px)',
                            overflowY: 'auto',
                            marginTop: '20px',
                            margin: '0 20px',
                        }}
                    >
                        <AllInfoExpanded />
                    </div>
                </>
            )}
            {manageAssetId !== 0 && <PropertyInfo />}
        </>
    );
}
